<template>
    <v-dialog
        v-model="dialog"
        max-width="500px"
        :persistent="true"
        :no-click-animation="true"
    >
        <v-card dark v-if="dialog">
            <v-card-title>
                <span class="query-headline">
                    {{$t('instance.query_fields.edit_modal.edit_fields', {resource_model : resourceQuery.model_name})}}
                </span>
            </v-card-title>

            <v-card-text>
                <v-container grid-list-md>
                    <select-queries
                        :parent-selected-elements="resourceQuery.search_fields"
                        :available-fields="searchFieldsNames"
                        :label="$t('instance.query_fields.edit_modal.search')"
                        :hint="$t('instance.query_fields.edit_modal.search_hint')"
                        item-text="value"
                        @on-new-elements-selected="resourceQuery.search_fields=$event"
                    ></select-queries>
                    <select-queries
                        :parent-selected-elements="resourceQuery.filter_fields"
                        :available-fields="filterFieldsNames"
                        :label="$t('instance.query_fields.edit_modal.filter')"
                        :hint="$t('instance.query_fields.edit_modal.filter_hint')"
                        @on-new-elements-selected="resourceQuery.filter_fields=$event"
                    ></select-queries>
                    <select-queries
                        :parent-selected-elements="resourceQuery.display_fields"
                        :available-fields="displayFieldsNames"
                        :label="$t('instance.query_fields.edit_modal.display')"
                        :hint="$t('instance.query_fields.edit_modal.display_hint')"
                        @on-new-elements-selected="resourceQuery.display_fields=$event"
                    ></select-queries>
                    <select-queries
                        :parent-selected-elements="resourceQuery.ordering_fields"
                        :available-fields="orderingFieldsNames"
                        :label="$t('instance.query_fields.edit_modal.ordering')"
                        item-text="value"
                        :hint="$t('instance.query_fields.edit_modal.ordering_hint')"
                        @on-new-elements-selected="resourceQuery.ordering_fields=$event"
                    >
                        <template
                            slot="item"
                            slot-scope="data"
                        >
                            <!-- laisser le `@click=""` pour garder le visuel de hover (oui c'est null mais apparement c'est comme ça que ça marche avec vuetify -_-) -->
                            <v-list-item  @click="">
                                <v-list-item-action>
                                    <v-checkbox v-model="resourceQuery.ordering_fields" :value="data.item.value"></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                    <v-list-item-subtitle v-html="data.item.subTitle"></v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </select-queries>
                    <select-queries
                        :parent-selected-elements="resourceQuery.export_fields"
                        :available-fields="exportFieldsNames"
                        :label="$t('instance.query_fields.edit_modal.export')"
                        :hint="$t('instance.query_fields.edit_modal.export_hint')"
                        item-text="value"
                        @on-new-elements-selected="resourceQuery.export_fields=$event"
                    >
                        <template
                            slot="item"
                            slot-scope="data"
                        >
                            <!-- laisser le `@click=""` pour garder le visuel de hover (oui c'est null mais apparement c'est comme ça que ça marche avec vuetify -_-) -->
                            <v-list-item  @click="">
                                <v-list-item-action>
                                    <v-checkbox v-model="resourceQuery.export_fields" :value="data.item.value"></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                    <v-list-item-subtitle v-html="data.item.subTitle"></v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </select-queries>
                </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <div class="dialog-confirm-buttons">
                    <v-btn @click="close">{{$t('instance.query_fields.edit_modal.btn_cancel')}}</v-btn>
                    <v-btn color="info" @click="save">{{$t('instance.query_fields.edit_modal.btn_save')}}</v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { ResourceQueries } from '@/components/page/Instance/DataModel/schema-modelisation.js';
import SelectQueries from './select-query.vue';
import { cloneDeep } from 'lodash';
export default {

    components: {
        SelectQueries,
    },

    props: {

    },

    data (){
        return {
            dialog: false,
            resourceQuery: {},
            model: {},
            schema: {},
        };
    },

    computed: {

        icon() {
            if (this.likesAllFruit) return 'mdi-close-box'
            if (this.likesSomeFruit) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        availableFields (){
            return this.model.fields;
        },
        listFieldsName (){
            return this.availableFields.map((field) => field.name);
        },
        displayFieldsNames(){
            return this.availableFields.filter((field)=> field.datatype !== 'm2m').map((field)=> field.name)
        },
        filterFieldsNames(){
            let names = cloneDeep(this.listFieldsName);
            let fkFields = this.availableFields.filter((field) => field.datatype === 'fk')
            for (let fkField of fkFields){
                let relatedModel = this.schema.modelList.find(
                    (model) => model.uid === fkField.attributes.to.uid
                )
                let filtrableRelatedModelFields = relatedModel.fields.filter(
                    (field) => !['fk', 'm2m'].includes(field.datatype)
                )
                names = names.concat(
                    filtrableRelatedModelFields.map(
                        (field) => `${fkField.name}__${field.name}`
                    )
                )
            }
            return names.sort((a, b) => a - b)
        },
        searchFieldsNames() {
            let data = this.resourceQueryFieldsName()
            return data.filter(query => !['fk', 'm2m', 'json'].includes(query.datatype))
        },
        orderingFieldsNames() {
            // Exclude JSON fields, FKs and M2Ms from ordering fields
            let data = this.resourceQueryFieldsName(false)
            return data.filter(query => !['fk', 'm2m', 'json'].includes(query.datatype))
        },
        exportFieldsNames() {
            return this.resourceQueryFieldsName()
        },
    },

    mounted (){

    },

    methods: {
        open (resourceQuery, model, schema){
            // On ne peux pas faire de queries sur les champs de type m2m
            this.$set(this, 'resourceQuery', new ResourceQueries({uid: resourceQuery.model_uid, name: resourceQuery.model_name}));
            this.$set(this, 'model', model);
            this.$set(this, 'schema', schema);
            this.resourceQuery.update(resourceQuery);
            this.dialog = true;
        },
        close (){
            this.dialog = false;
        },
        save (){
            this.$emit('on-resource-query-saved', this.resourceQuery);
        },
        updateResourceQuery(item){
            let queriesList = this.resourceQuery.export_fields;
            let value = item.fkField ? `${item.relatedModel}__${item.name}` : item.name;
            let index = queriesList.indexOf(value);
            if(index !== -1){
                queriesList.splice(index, 1);
            }else{
                queriesList.push(value);
            }
        },
        resourceQueryFieldsName (enableM2M){
            let relatedDatatypes = ['fk', 'm2m']
            if (enableM2M === false){
                relatedDatatypes = ['fk']
            }
            let data = this.availableFields.filter((field) => !['fk', 'm2m'].includes(field.datatype))
                .map((field) => {
                    return {
                        name: field.name,
                        value: field.name,
                        datatype: field.datatype,
                        subTitle: field.datatype
                    };
                }
            );
            let relatedFk = this.availableFields.filter((field) => relatedDatatypes.includes(field.datatype));
            let count = 0;
            for(let field of relatedFk){
                data.push({header: field.name});
                let relatedModel = this.schema.modelList.find((model) => model.uid === field.attributes.to.uid);
                data.push(...relatedModel.fields.filter((relatedModelField) => !['m2m', 'fk']
                    .includes(relatedModelField.datatype))
                    .map((relatedModelField) => {
                        return {
                            name: relatedModelField.name,
                            datatype: relatedModelField.datatype,
                            fkField: true,
                            relatedModel: field.name,
                            value: `${field.name}__${relatedModelField.name}`,
                            subTitle: `${field.name}__${relatedModelField.name}(${relatedModelField.datatype})`
                        };
                    })
                );
                count++;
            }
            return data;

        },
    },
};
</script>

<style lang="scss">
.v-subheader{
    font-weight: bold;
    font-size: large;
}
.query-headline{
    color: $main-light-color;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Instance/QueryFields/edit-modal.vue